import { useContext, useState, useRef, memo } from "react";

import classes from "./DrinkBar.module.css";

import DrinkBarExpand from "../DrinkBarExpand/DrinkBarExpand";
import CustomButton from "../../General_Elements/CustomButton/CustomButton";

import CartContext from "../../../store/cart-context";

// component for each cocktail returned by search
const DrinkBar = (props) => {
  const cartCtx = useContext(CartContext);
  const timeoutRef = useRef(null);
  const [showExpand, setShowExpand] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  // console.log("param-------", props.drink._id)
  // console.log("cart items-------", cartCtx.items)

  const result = cartCtx.items.find((item) => item._id === props.drink._id);

  // console.log("result-------", result.amount)

  // console.log("------------ RENDERING BARRRRRRRR: ", props.drink.title)

  // add cocktail to the cart
  const addToCartHandler = (event) => {
    event.stopPropagation();

    cartCtx.addItem({
      ...props.drink,
    });

    cartCtx.saveCart();

    setShowOverlay(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setShowOverlay(false);
    }, 500); // 2000 milliseconds = 2 seconds
  };

  // expand cocktail to show ingrdients
  const showExpandHandler = () => {
    setShowExpand(!showExpand);
  };

  return (
    <div className={classes.drink_bar_container}>
      <div className={classes.drink_bar} onClick={showExpandHandler}>
        <div
          className={classes.image_blocker}
          style={
            props.drink.ingCount === props.drink.ingredients.length
              ? { border: "solid 3px #68bb59", borderRadius: "15px" }
              : {}
          }
        >
          <img
            className={classes.drink_image}
            src={props.drink.image}
            alt="new"
          />
        </div>
        <div className={classes.drink_title}>
          {props.drink.title}
        </div>
        {result && showOverlay ? (
          <div className={classes.ingredient_count}>{result.amount}</div>
        ) : (
          <div className={classes.ingredient_count}>
            <sup>{props.drink.ingCount}</sup>&frasl;
            <sub>{props.drink.ingredients.length}</sub>
          </div>
        )}
        <div className={classes.add_button} onClick={addToCartHandler}>
          +
        </div>
      </div>
      {showExpand && (
        <DrinkBarExpand
          ingredients={props.drink.ingredients}
          onClose={showExpandHandler}
        />
      )}
    </div>
  );
};

export default memo(DrinkBar);
